angular.
module("dx.webapp.angular").
directive("languagePickerWrapper", function languagePickerWrapperDirective() {
	"use strict";
	return {restrict: "E", template: "<language-picker />"};
}).
directive("dxLoginFormWrapper", function loginFormWrapperDirective() {
	"use strict";
	return {restrict: "E", template: "<dx-login-form />"};
}).
directive("dxRegisterWrapper", function registerWrapperDirective() {
	"use strict";
	return {
		restrict: "E",
		template: "<dx-register invite='invite'>",
		bindings: {
			invite: "=",
		},
	};
}).
directive("dxTooltipWrapper", function tooltipWrapper() {
	"use strict";
	return {
		restrict: "E",
		template: "<dx-tooltip preferred-direction='{{preferredDirection}}' rtl='rtl'>" +
			"<ng-transclude></ng-transclude>" +
			"</dx-tooltip>",
		bindings: {
			preferredDirection: "<direction",
			rtl: "<",
		},
	};
});
